"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggerBrowserConfiguration = void 0;
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _loggerConfigurationSchema = require("../loggerConfigurationSchema");
var LOCAL_STORAGE_KEY = 'ori-logger-configuration';
var LoggerBrowserConfiguration = exports.LoggerBrowserConfiguration = {
    get: function() {
        var localStorageValue = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!localStorageValue) {
            return null;
        }
        try {
            var parsed = _loggerConfigurationSchema.loggerConfigurationSchema.partial().safeParse(JSON.parse(localStorageValue));
            var _parsed_data;
            return (_parsed_data = parsed.data) !== null && _parsed_data !== void 0 ? _parsed_data : null;
        } catch (e) {
            return null;
        }
    },
    set: function(input) {
        var validated = _loggerConfigurationSchema.loggerConfigurationSchema.parse(input);
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(validated));
    },
    update: function(input) {
        var validated = _loggerConfigurationSchema.loggerConfigurationSchema.partial().parse(input);
        var current = this.get();
        var mergedWithCurrent = current ? (0, _deepmerge.default)(current, validated) : validated;
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(mergedWithCurrent));
    }
}; //# sourceMappingURL=LoggerBrowserConfiguration.js.map
